<template>
  <div class="form-input-wrapper multiple-wrapper">
    <label class="form-label">
      <span>{{ label }}</span>
    </label>
    <div class="autocomplete-wrapper">
      <input
        class="form-autocomplete"
        type="text"
        :value="value"
        :id="name"
        :placeholder="placeholder+' i kliknite na kvačicu'"
        @input="value = $event.target.value"
        @keyup.enter="dodajElement()"
        title='Pritisnite ENTER ili kliknite na kvačicu za potvrdu unosa'
      />
      <div class="autocomplete-confirm" @click="dodajElement()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 11 9"><g><g><path fill="#3326AE" d="M9.073.32l1.896 1.86-6.16 6.044-.356-.35-.015.014-3.526-3.46 1.833-1.8L4.733 4.58z"/></g></g></svg>
      </div>
    </div>
    <div class="results-selected-wrapper" style="display: flex; opacity: 1">
      <div v-for="(el, key) in values" :key="key" class="result-selected">
        <div class="remove-result" @click="removeElement(el)">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
          >
            <g>
              <g>
                <path
                  fill="#eae9ee"
                  d="M18.774 3.2c4.301 4.3 4.301 11.274 0 15.574-4.3 4.301-11.273 4.301-15.574 0-4.3-4.3-4.3-11.273 0-15.574 4.3-4.3 11.274-4.3 15.574 0z"
                />
              </g>
              <g>
                <path
                  fill="#191e2c"
                  d="M12.388 14.263l-1.404-1.41-1.405 1.41a1.321 1.321 0 0 1-1.872 0 1.331 1.331 0 0 1 0-1.879l1.404-1.408-1.404-1.409a1.331 1.331 0 0 1 0-1.878 1.321 1.321 0 0 1 1.872 0l1.405 1.408 1.404-1.408a1.321 1.321 0 0 1 1.872 0c.517.518.517 1.36 0 1.878l-1.404 1.409 1.404 1.408c.517.519.517 1.36 0 1.879a1.321 1.321 0 0 1-1.872 0z"
                />
              </g>
            </g>
          </svg>
        </div>
        <div :class="'result-name rsn' + key">
          <span class="result-name-span">{{ el.length > 55 ? el.slice(0,55)+'...' : el }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["label", "name", "placeholder","base"],
  data() {
    return {
      value: "",
      values: [],
    };
  },
  methods: {
    setData() {
      if(this.base.length > 0)
      {
        this.values = this.base
      }
    },
    dodajElement() {
      if (!this.values.includes(this.value) && !this.value == "") {
        this.values.push(this.value);
      }
      this.value = "";
    },
    removeElement(el) {
      this.values = this.values.filter((mail) => mail != el);
    },
  },
  mounted() {
    let vm = this;
    vm.$nextTick(function () {
      this.inputType = vm.id;
      setTimeout(this.setData, 1000);
      //   setTimeout(this.prijedlogBrojPredmeta, 1000);
    });
  },
};
</script>